export const works = [
  {
    id: "w01",
    title: "回归者的学院生活",
    author: "玄午",
    category: "韩漫",
    genres: ["校园", "奇幻", "热血"],
    status: "连载中",
    latestChapter: "第 128 话",
    updatedAt: "2 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20determined%20young%20man%20in%20a%20dark%20academy%20uniform%20standing%20before%20a%20grand%20stone%20school%20gate%20at%20golden%20hour%2C%20warm%20amber%20and%20crimson%20color%20palette%2C%20dramatic%20rim%20light%2C%20simple%20clean%20background%2C%20stylized%20anime%20manhwa%20art%2C%20high%20detail&width=600&height=800&seq=dm-work-01&orientation=portrait",
    description:
      "重回入学第一天，被退学的少年带着记忆再次踏入学院。面对旧日宿敌与未知试炼，他决定这一次改写所有人的结局。",
    rating: "9.6",
    views: "326.4 万",
  },
  {
    id: "w02",
    title: "怪物猎人日志",
    author: "Shin & 白鸦",
    category: "韩漫",
    genres: ["奇幻", "战斗", "悬疑"],
    status: "连载中",
    latestChapter: "第 94 话",
    updatedAt: "5 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20hooded%20monster%20hunter%20holding%20a%20glowing%20blade%20facing%20a%20giant%20shadow%20beast%20in%20a%20misty%20forest%2C%20warm%20orange%20and%20deep%20red%20lighting%2C%20cinematic%20composition%2C%20simple%20dark%20background%2C%20stylized%20manhwa%20art&width=600&height=800&seq=dm-work-02&orientation=portrait",
    description:
      "猎人工会档案里没有记录过的怪物，正在一座座城市边缘苏醒。年轻猎人接下最后的委托，用一把会呼吸的刀揭开狩猎背后的真相。",
    rating: "9.4",
    views: "288.1 万",
  },
  {
    id: "w03",
    title: "顶楼公寓",
    author: "尹世罗",
    category: "韩漫",
    genres: ["都市", "悬疑", "剧情"],
    status: "连载中",
    latestChapter: "第 76 话",
    updatedAt: "昨天",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20modern%20high%20rise%20apartment%20corridor%20at%20night%20with%20one%20woman%20looking%20back%20over%20her%20shoulder%2C%20tense%20suspense%20mood%2C%20warm%20amber%20lamps%20against%20muted%20neutral%20shadows%2C%20simple%20background%2C%20stylized%20manhwa%20art&width=600&height=800&seq=dm-work-03&orientation=portrait",
    description:
      "住在顶楼的女人从不出门，却知道整栋楼所有人的秘密。搬进隔壁的租客渐渐发现，这栋公寓的每一户都在等同一件事发生。",
    rating: "9.2",
    views: "174.5 万",
  },
  {
    id: "w04",
    title: "财阀家的小女儿",
    author: "郑 미루",
    category: "韩漫",
    genres: ["都市", "剧情", "日常"],
    status: "已完结",
    latestChapter: "全 210 话 · 完结",
    updatedAt: "3 天前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20an%20elegant%20young%20woman%20in%20a%20tailored%20cream%20coat%20standing%20in%20a%20grand%20marble%20hall%2C%20refined%20warm%20beige%20and%20gold%20palette%2C%20soft%20studio%20lighting%2C%20simple%20clean%20background%2C%20stylized%20manhwa%20art&width=600&height=800&seq=dm-work-04&orientation=portrait",
    description:
      "重生回到家族尚未崩塌的那一年，她决定不再做被抛弃的那一个。这一世，她要亲手管理属于自己的那份家业，也守住真正的家人。",
    rating: "9.5",
    views: "412.9 万",
  },
  {
    id: "w05",
    title: "与恶龙的契约",
    author: "Hanabi",
    category: "韩漫",
    genres: ["奇幻", "恋爱", "剧情"],
    status: "连载中",
    latestChapter: "第 61 话",
    updatedAt: "8 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20young%20woman%20reaching%20toward%20a%20reclining%20red%20dragon%20in%20a%20warm%20candlelit%20cave%2C%20romantic%20fantasy%20mood%2C%20golden%20and%20crimson%20palette%2C%20soft%20glow%2C%20simple%20dark%20background%2C%20stylized%20manhwa%20art&width=600&height=800&seq=dm-work-05&orientation=portrait",
    description:
      "为了救活病重的弟弟，她与沉睡千年的恶龙签下契约。代价是成为它的新娘，而龙的温柔背后，藏着一段被人类抹去的往事。",
    rating: "9.3",
    views: "233.7 万",
  },
  {
    id: "w06",
    title: "山海关夜行",
    author: "老莫",
    category: "国漫",
    genres: ["玄幻", "悬疑", "志怪"],
    status: "连载中",
    latestChapter: "第 143 话",
    updatedAt: "4 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20lone%20traveler%20holding%20a%20paper%20lantern%20walking%20through%20an%20ancient%20chinese%20mountain%20pass%20gate%20at%20night%2C%20ink%20painting%20inspired%2C%20warm%20torchlight%20and%20deep%20shadow%2C%20misty%20simple%20background%2C%20guofeng%20manhua%20art&width=600&height=800&seq=dm-work-06&orientation=portrait",
    description:
      "夜里过关的人，从不回头。守关的年轻人在同一道关口遇到了三位形貌各异的旅人，而他们嘴里都念着同一个已经不在的名字。",
    rating: "9.4",
    views: "198.3 万",
  },
  {
    id: "w07",
    title: "御剑行",
    author: "青翎",
    category: "国漫",
    genres: ["仙侠", "热血", "武侠"],
    status: "连载中",
    latestChapter: "第 117 话",
    updatedAt: "6 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20young%20swordsman%20in%20flowing%20white%20robes%20riding%20a%20flying%20sword%20above%20cloud%20covered%20mountains%2C%20warm%20sunrise%20orange%20and%20pale%20gold%20palette%2C%20dynamic%20composition%2C%20simple%20sky%20background%2C%20guofeng%20manhua%20art&width=600&height=800&seq=dm-work-07&orientation=portrait",
    description:
      "剑宗最不起眼的杂役，意外得到一柄认主的旧剑。从山门到天下，他一路御剑而行，只问一件事：剑究竟为谁而鸣。",
    rating: "9.1",
    views: "156.8 万",
  },
  {
    id: "w08",
    title: "长安十二时",
    author: "墨白工作室",
    category: "国漫",
    genres: ["历史", "悬疑", "剧情"],
    status: "已完结",
    latestChapter: "全 168 话 · 完结",
    updatedAt: "1 周前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20an%20ancient%20chinese%20city%20street%20with%20lanterns%20and%20a%20cloaked%20official%20holding%20a%20scroll%2C%20historical%20mystery%20mood%2C%20warm%20lantern%20glow%20and%20earth%20tones%2C%20simple%20detailed%20background%2C%20guofeng%20manhua%20art&width=600&height=800&seq=dm-work-08&orientation=portrait",
    description:
      "长安城一天之内接连出了三桩命案，凶手留下的线索都指向十二年前的旧案。负责查案的小吏只有十二个时辰，找出真相或成为下一个。",
    rating: "9.6",
    views: "267.2 万",
  },
  {
    id: "w09",
    title: "废土拾荒人",
    author: "铁皮",
    category: "国漫",
    genres: ["科幻", "末世", "热血"],
    status: "连载中",
    latestChapter: "第 88 话",
    updatedAt: "11 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20scavenger%20in%20patched%20gear%20standing%20on%20a%20rusty%20wreck%20looking%20at%20a%20ruined%20skyline%2C%20post%20apocalyptic%20mood%2C%20dusty%20ochre%20and%20rust%20red%20palette%2C%20simple%20hazy%20background%2C%20stylized%20manhua%20art&width=600&height=800&seq=dm-work-09&orientation=portrait",
    description:
      "在大灾变之后的世界，拾荒者们靠回收旧时代残骸为生。少年捡到一枚仍在运转的芯片，从此被卷进两个营地之间延续了百年的争夺。",
    rating: "9.0",
    views: "121.6 万",
  },
  {
    id: "w10",
    title: "外卖侠的日常",
    author: "阿旺",
    category: "国漫",
    genres: ["都市", "搞笑", "日常"],
    status: "连载中",
    latestChapter: "第 205 话",
    updatedAt: "1 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20cheerful%20delivery%20rider%20with%20a%20warm%20orange%20jacket%20riding%20a%20scooter%20through%20a%20bustling%20cartoon%20city%20street%2C%20playful%20comedy%20mood%2C%20warm%20colorful%20palette%2C%20simple%20clean%20background%2C%20stylized%20manhua%20art&width=600&height=800&seq=dm-work-10&orientation=portrait",
    description:
      "白天送外卖，晚上做好人。一名普通骑手总能撞上城市里各种离谱又暖心的麻烦，每一单都送出了不一样的结局。",
    rating: "8.8",
    views: "143.4 万",
  },
  {
    id: "w11",
    title: "星海列车",
    author: "Nana 计划",
    category: "动漫",
    genres: ["科幻", "治愈", "剧情"],
    status: "连载中",
    latestChapter: "第 52 话",
    updatedAt: "9 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20vintage%20train%20gliding%20between%20glowing%20planets%20in%20deep%20space%20with%20one%20passenger%20looking%20out%20the%20window%2C%20warm%20amber%20window%20light%20against%20a%20deep%20dark%20starry%20background%2C%20dreamy%20simple%20composition%2C%20anime%20art&width=600&height=800&seq=dm-work-11&orientation=portrait",
    description:
      "一列只在深夜出现的列车，载着乘客前往各自的遗憾之处。列车员唯一的规矩是：到站前，请务必想清楚要不要下车。",
    rating: "9.3",
    views: "167.9 万",
  },
  {
    id: "w12",
    title: "剑与樱",
    author: "藤井遥",
    category: "动漫",
    genres: ["武侠", "青春", "剧情"],
    status: "连载中",
    latestChapter: "第 73 话",
    updatedAt: "昨天",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20student%20swordsman%20standing%20under%20a%20blossoming%20pink%20sakura%20tree%20holding%20a%20wooden%20sword%2C%20gentle%20youthful%20mood%2C%20warm%20pink%20and%20cream%20palette%2C%20soft%20light%2C%20simple%20background%2C%20anime%20art&width=600&height=800&seq=dm-work-12&orientation=portrait",
    description:
      "剑道社里最迟钝的男生，和成绩最好的女生约定：谁先拿下全国大赛，谁就答应对方一件事。整个春天，他们都在为同一个约定挥剑。",
    rating: "9.2",
    views: "189.7 万",
  },
  {
    id: "w13",
    title: "猫之邮局",
    author: "月森",
    category: "动漫",
    genres: ["奇幻", "治愈", "日常"],
    status: "已完结",
    latestChapter: "全 96 话 · 完结",
    updatedAt: "2 周前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20cozy%20tiny%20post%20office%20with%20several%20cats%20sorting%20letters%20and%20warm%20lantern%20light%20in%20the%20window%2C%20warm%20cream%20and%20amber%20palette%2C%20storybook%20cozy%20mood%2C%20simple%20charming%20background%2C%20anime%20art&width=600&height=800&seq=dm-work-13&orientation=portrait",
    description:
      "城市角落有间只在雨天营业的邮局，员工全是会写字的猫。寄出一封无法投递的信，猫们会替你找到收信人——哪怕那个人早已不在。",
    rating: "9.5",
    views: "204.5 万",
  },
  {
    id: "w14",
    title: "深夜拉面屋",
    author: "南云食堂",
    category: "动漫",
    genres: ["美食", "日常", "治愈"],
    status: "连载中",
    latestChapter: "第 158 话",
    updatedAt: "3 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20small%20late%20night%20ramen%20shop%20with%20a%20steaming%20bowl%20and%20a%20warm%20lit%20counter%20under%20a%20red%20lantern%2C%20cozy%20food%20mood%2C%20warm%20amber%20and%20deep%20red%20palette%2C%20simple%20background%2C%20anime%20art&width=600&height=800&seq=dm-work-14&orientation=portrait",
    description:
      "只在午夜十二点后开门的拉面屋，老板从不多问客人来意。一碗面下肚，每个人都能带走一点重新出发的力气。",
    rating: "9.1",
    views: "152.2 万",
  },
  {
    id: "w15",
    title: "龙脉守护者",
    author: "赤霄",
    category: "国漫",
    genres: ["玄幻", "热血", "动作"],
    status: "连载中",
    latestChapter: "第 132 话",
    updatedAt: "7 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20young%20guardian%20with%20glowing%20markings%20raising%20a%20hand%20against%20a%20coiling%20golden%20dragon%20in%20the%20sky%2C%20epic%20fantasy%20mood%2C%20warm%20gold%20and%20crimson%20palette%2C%20dynamic%20simple%20background%2C%20guofeng%20manhua%20art&width=600&height=800&seq=dm-work-15&orientation=portrait",
    description:
      "大地之下沉睡着九条龙脉，守护它们的人一代只传一人。当代守护者还是个少年，而第一条龙脉已经开始断裂。",
    rating: "9.3",
    views: "215.6 万",
  },
  {
    id: "w16",
    title: "都市灵能事务所",
    author: "夜猫",
    category: "国漫",
    genres: ["都市", "灵异", "搞笑"],
    status: "连载中",
    latestChapter: "第 97 话",
    updatedAt: "10 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20small%20city%20office%20storefront%20with%20glowing%20talismans%20and%20a%20relaxed%20young%20exorcist%20leaning%20at%20the%20door%2C%20playful%20supernatural%20mood%2C%20warm%20amber%20and%20smoky%20neutral%20palette%2C%20simple%20background%2C%20stylized%20manhua%20art&width=600&height=800&seq=dm-work-16&orientation=portrait",
    description:
      "别人开事务所接委托，他开事务所专治各种不靠谱的灵异事件。收费合理，售后自理，唯一原则是不接半夜十二点之后的单——除非加钱。",
    rating: "8.9",
    views: "138.3 万",
  },
  {
    id: "w17",
    title: "雪国来客",
    author: "岸本遥",
    category: "动漫",
    genres: ["剧情", "治愈", "悬疑"],
    status: "连载中",
    latestChapter: "第 44 话",
    updatedAt: "昨天",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20small%20snow%20covered%20town%20with%20one%20silhouetted%20traveler%20arriving%20at%20a%20warm%20lit%20station%20at%20dusk%2C%20quiet%20melancholic%20mood%2C%20warm%20window%20light%20against%20cool%20pale%20snow%2C%20simple%20background%2C%20anime%20art&width=600&height=800&seq=dm-work-17&orientation=portrait",
    description:
      "每年初雪那天，小镇都会来一个不记得自己名字的旅人。今年来的是个孩子，而她带着一封写给全镇的信。",
    rating: "9.0",
    views: "112.8 万",
  },
  {
    id: "w18",
    title: "赛博之城的雨",
    author: "Neon 工作室",
    category: "国漫",
    genres: ["科幻", "悬疑", "动作"],
    status: "连载中",
    latestChapter: "第 69 话",
    updatedAt: "12 小时前",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20comic%20cover%20illustration%20of%20a%20lone%20figure%20in%20a%20translucent%20coat%20walking%20through%20a%20neon%20lit%20rainy%20future%20city%20street%2C%20cyberpunk%20mood%2C%20warm%20orange%20and%20magenta%20neon%20reflections%2C%20simple%20atmospheric%20background%2C%20stylized%20manhua%20art&width=600&height=800&seq=dm-work-18&orientation=portrait",
    description:
      "在这座下不完雨的城市里，记忆是可以买卖的商品。一名靠找回丢失记忆为生的私家侦探，接下了一单关于自己的委托。",
    rating: "9.2",
    views: "176.1 万",
  },
];